export default "__VITE_ASSET__8214283b__"